import React, { useState } from 'react';
import { Box, Card, CardContent, CardMedia, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const ServiceContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '20px',
  padding: '50px',
}));

const ServiceHeading = styled(Typography)(({ theme }) => ({
  fontSize: '2rem',
  fontWeight: 'bold',
  textAlign: 'center',
  marginBottom: '20px',
}));

const ServiceGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)', // Three cards per row
  gap: '20px',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr', // One card per row for small screens
  },
}));

const ServiceCard = styled(Card)(({ theme }) => ({
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
  borderRadius: '10px',
}));

const ServiceCardMedia = styled(CardMedia)(({ theme }) => ({
  height: '200px',
}));

const ServiceCardContent = styled(CardContent)(({ theme }) => ({
  textAlign: 'center',
}));

export default function Service() {
  const [expandedCard, setExpandedCard] = useState(null);

  const services = [
    {
      title: 'ANALYSES MINERALES ',
      image: '/img/1.jpeg',
      shortNote: 'This is a brief description of Service 1.',
      fullText: 'This is the full description of Service 1, providing more details about what it offers.',
    },
    {
      title: 'CONTROLES',
      image: '/img/14.jpeg',
      shortNote: 'This is a brief description of Service 2.',
      fullText: 'This is the full description of Service 2, providing more details about what it offers.',
    },
    {
      title: 'RECHERCHES',
      image: '/img/16.jpeg',
      shortNote: 'This is a brief description of Service 3.',
      fullText: 'This is the full description of Service 3, providing more details about what it offers.',
    },
    {
      title: 'EXPERTISES',
      image: '/img/36.jpeg',
      shortNote: 'This is a brief description of Service 4.',
      fullText: 'This is the full description of Service 4, providing more details about what it offers.',
    },
    {
      title: 'CONSEILS',
      image: '/img/11.jpeg',
      shortNote: 'This is a brief description of Service 5.',
      fullText: 'This is the full description of Service 5, providing more details about what it offers.',
    },
    {
      title: 'ANALYSES DE DONNEES',
      image: '/img/8.jpeg',
      shortNote: 'This is a brief description of Service 6.',
      fullText: 'This is the full description of Service 6, providing more details about what it offers.',
    },
  ];

  const handleToggle = (index) => {
    setExpandedCard(expandedCard === index ? null : index); // Toggle only the clicked card
  };

  return (
    <ServiceContainer style={{ backgroundColor: 'grey', color: 'white', marginTop: '50px' }} id="services">
      <ServiceHeading>Nos Services</ServiceHeading>
        <Typography variant="body1" style={{ textAlign: 'center', marginBottom: '20px' }}>
            Nous offrons une large gamme de services pour répondre à vos besoins. Explorez nos offres ci-dessous:
          </Typography>
      <ServiceGrid>
        {services.map((service, index) => (
          <ServiceCard key={index}>
            <Typography variant="h6" gutterBottom style={{textAlign: 'center', fontWeight: 'bold'}}>
                {service.title}
              </Typography>
            <ServiceCardMedia component="img" image={service.image} alt={service.title} />
            <ServiceCardContent>
              
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="body2" color="textSecondary">
                  {service.shortNote}
                </Typography>
                <IconButton onClick={() => handleToggle(index)} color="primary">
                  {expandedCard === index ? <RemoveIcon /> : <AddIcon />}
                </IconButton>
              </Box>
              {expandedCard === index && (
                <Typography variant="body2" color="textSecondary" style={{ marginTop: '10px' }}>
                  {service.fullText}
                </Typography>
              )}
            </ServiceCardContent>
          </ServiceCard>
        ))}
      </ServiceGrid>
    </ServiceContainer>
  );
}